import { Android, Apple } from "@mui/icons-material";
import { Button, CardActions, CardContent, Typography } from "@mui/material";
import { DateTime } from "luxon";
import React from "react";
import { DialogHeader } from "../../generics/dialog-header";

type AttendExperienceDialogProps = {
  experience: {
    id: number;
    headline: string;
    eventBeginDate: string;
    startTime: string;
  };
};

export const AttendExperienceDialog: React.FC<AttendExperienceDialogProps> = ({ experience }) => (
  <>
    <DialogHeader
      title={`You're Attending ${experience.headline}`}
      subheader={`${DateTime.fromISO(experience.eventBeginDate, {
        zone: "utc",
      }).toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY)} @ ${experience.startTime}`}
    />
    <CardContent>
      <Typography>
        Everything is more fun on the CANNA42 app! It’s your place for real community, culture, and all things cannabis.
        Earn points for creating content, find like-minded people, and discover fun things to do!
      </Typography>
    </CardContent>
    <CardActions
      sx={{
        margin: -2,
        mt: 2,
        px: 2,
        pt: 2,
        pb: 3,
        flexDirection: { xs: "column", sm: "row" },
        backgroundColor: "#000",
      }}
    >
      <Button
        href={"https://apps.apple.com/us/app/canna42/id6478886245"}
        target="_blank"
        variant="outlined"
        sx={{ color: "#FFF", borderColor: "#FFF", m: 0.5 }}
        fullWidth
        startIcon={<Apple />}
      >
        Get For iOS
      </Button>
      <Button
        href={"https://apps.apple.com/us/app/canna42/id6478886245"}
        target="_blank"
        variant="outlined"
        sx={{ color: "#FFF", borderColor: "#FFF", m: 0.5 }}
        fullWidth
        startIcon={<Android />}
      >
        Get For Android
      </Button>
    </CardActions>
  </>
);
